import { render, staticRenderFns } from "./Doctor.vue?vue&type=template&id=31a63a35&scoped=true&"
import script from "./Doctor.vue?vue&type=script&lang=js&"
export * from "./Doctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a63a35",
  null
  
)

export default component.exports